<!--
  作者：顾先生
-->
<template>
  <div class="app-container">
<!--    路由占位符-->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  methods: {
    _isMobile () {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  },
  props: {},
  data () {
    return {

    }
  },
  computed: {},
  watch: {},
  created () {
    // 获取URL的查询字符串部分  window.location.href https://www.jcxyrz.org.cn?JcxyR=6892c11467b84
    const queryString = window.location.href
    const urlParams = queryString.lastIndexOf('?')
    const url2 = queryString.substring(urlParams + 1)
    const b = url2.indexOf('=')
    const c = url2.substring(0, b)
    const d = url2.split('=')
    localStorage.setItem('zheng1', c)
    localStorage.setItem('zheng2', d[1])
  },
  mounted () {
    if (this._isMobile()) {
      this.$router.replace('/move')
    } else {
      this.$router.replace('/')
    }
  }

}
</script>

<style scoped lang="less">

</style>
